<template>
  <div id="app" :class="[checkinPage ? 'checkin-background' : '']">

    <!--start of notification section on top right-->
    <notifications group="top-right-common" position="top right" width="auto">
      <template slot="body" slot-scope="props">
        <div :class="['notification', 'custom-notification', props.item.type.notificationType, props.item.type.hideClose ? 'hide-close' : '']">
          <div class="notification-content-wrap">
            <div class="notification-title">{{props.item.title}}</div>
            <div class="notification-content" v-html="props.item.text"></div>
            <div class="notification-btn-wrap">
              <div :class="['notification-close-btn', 'notification-btn', props.item.type.notificationType]" v-if="props.item.type.textCloseBtn" @click="props.close" >{{props.item.type.textCloseBtn}}</div>
              <div v-if="props.item.type.linkBtn">
                <a :href="btn.url" :target="btn.target" v-for="(btn, key) in props.item.type.linkBtn" :key="key"
                   :class="['notification-link-btn', 'notification-btn', props.item.type.notificationType]" @click="props.close">{{btn.btnText}}</a>
              </div>
            </div>

          </div>
          <div class="notification-close" @click="props.close" v-if="props.item.type.hideClose !== true">
            <i class="material-icons">clear</i>
          </div>
        </div>
      </template>
    </notifications>
    <!--end of notification section on top right-->

    <loadingDiv type="full-page-loading"></loadingDiv>
    <!--<img src="./assets/logo.png">-->
    <mu-appbar v-if="!hideBar" :zDepth="0" class="header-content" title="" :class="{'nav-hide': !open, 'login-page': !login, 'open': open}">

      <template v-if="!login">
        <a :href="'https://www.mondoconnex.com'" target="_blank">
          <img src="~./assets/mondoconnex-menu-logo.svg" class="nav-logo" slot="left"/>
        </a>

        <mu-button slot="right" v-if="$route.path !== '/registration'" @click="changeToPage($settings.basicURL + '/registration')" class="top-button mobile-hide"
                   textColor="white" color="secondary" style="height: 30px;">
          Registration
        </mu-button>

        <mu-button slot="right" @click="changeToPage($settings.basicURL + '/login')" class="top-button mobile-hide"
                   textColor="white" color="secondary" style="height: 30px;">
          Login
        </mu-button>

        <mu-button slot="right" flat @click="toggleNav" class="demo-flat-button menu-icon mobile-show" color="primary">
          <mu-icon left value="menu" />Menu
        </mu-button>

      </template>

      <template v-if="login">
        <div id="nav-title">{{$route.name}}</div>
        <a :href="'https://www.mondoconnex.com'" target="_blank">
          <img src="~./assets/mondoconnex-menu-logo.svg" class="nav-logo mobile-show" slot="left"/>
        </a>

        <mu-button slot="right" @click="toggleNav" style="color: black;padding: 0; margin-top: 3px;" class="menu-icon mobile-hide" v-show="!desktop">
          <mu-icon left value="menu"/>
        </mu-button>
        <!--<mu-flat-button class="top-button" color="white" :label="'Hi ' + name" slot="right" />-->
        <mu-button  slot="right" @click="logout" class="top-button mobile-hide" textColor="black">
          <mu-icon value="input" left />Log out
        </mu-button>

        <mu-button slot="right" flat @click="toggleNav" class="demo-flat-button menu-icon mobile-show" color="primary">
          <mu-icon left value="menu" />Menu
        </mu-button>
      </template>
    </mu-appbar>

    <app-nav v-if="!hideBar" @change="handleMenuChange" @close="toggleNav" :open="open" :docked="docked" @logout="logout"></app-nav>

    <div class="content" :class="{'nav-hide': !open, 'hide-bar': hideBar, 'checkin-background': checkinPage}" :style="{'padding-bottom': login === true && !hideBar ? '100px': 'auto'}">
      <transition name="fade" mode="out-in">
        <router-view :key="$route.fullPath"></router-view>
      </transition>
    </div>
    <div v-if="login && !checkinPage" class="bottom-image desktop" style="bottom: 0;position: fixed;    width: calc(100vw - 256px);left: 256px;">
      <div>
        <a href="https://bit.ly/30GsULD" target="_blank"><img style="max-width: 80%;max-height: 150px;" src="~./assets/img/Portal-Banner-Mondo-Menu.png" /></a>
      </div>
    </div>
    <div v-if="login && !checkinPage" class="bottom-image mobile">
      <div>
        <a href="https://bit.ly/30GsULD" target="_blank"><img style="max-width: 95%;max-height: 150px;" src="~./assets/img/Portal-Banner-Mondo-Menu.png" /></a>
      </div>
    </div>
  </div>
</template>

<script>
  import advTheme from 'raw-loader!./components/theme/advTheme.txt'
  // import sensisTheme from 'raw-loader!./components/theme/sensisTheme.txt'
  import store from './vuex/store'
  import AppNav from './components/common/asider'
  import loadingDiv from './components/common/loading'
  import * as types from './vuex/mutation-types'

  export default {
    store,
    name: 'MondoCheckInPortal',
    components: {
      'app-nav': AppNav,
      'loadingDiv': loadingDiv
    },
    beforeCreate () {
      // check system and set to store
      const hostname = location.host
      this.$store.commit('SET_SYSTEM_NAME', {'hostname': hostname, 'commonState': this.$store.state.common})
      this.$store.commit('SET_SYSTEM_URL_COUNTRY', hostname)
    },
    data () {
      const desktop = isDesktop()
      return {
        open: desktop,
        docked: desktop,
        desktop: desktop,
        hideBar: true,
        checkinPage: false,
        title: '',
        theme: 'advTheme',
        themes: {
          advTheme
        }
      }
    },

    computed: {
      login: function () {
        return this.$store.state.common.login
      },
      name: function () {
        return this.$store.state.common.name
      }
    },
    watch: {
      login: function (value) {
        if (value && isDesktop()) {
          this.open = true
        }
        this.changeNav()
      },
      '$route': 'routeChange'
    },

    methods: {
      changeTheme (theme) {
        this.theme = theme
        const styleEl = this.getThemeStyle()
        styleEl.innerHTML = this.themes[theme] || ''
      },
      getThemeStyle () {
        const themeId = 'muse-theme'
        let styleEl = document.getElementById(themeId)
        if (styleEl) return styleEl
        styleEl = document.createElement('style')
        styleEl.id = themeId
        document.body.appendChild(styleEl)
        return styleEl
      },
      changeToPage  (url) {
        this.$router.push({path: url})
      },
      eventFire (el, etype) {
        if (el.fireEvent) {
          el.fireEvent('on' + etype)
        } else {
          var evObj = document.createEvent('Events')
          evObj.initEvent(etype, true, false)
          el.dispatchEvent(evObj)
        }
      },
      routeChange () {
        if (this.$route.path === '/registration' || this.$route.path.indexOf('/checkin/') >= 0 || this.$route.path === '/' || this.$route.path === '') {
          this.hideBar = true
        } else {
          this.hideBar = false
        }
        if (this.$route.path.indexOf('/checkin/') >= 0) {
          this.checkinPage = true
        } else {
          this.checkinPage = false
        }
        console.log(this.$route)
      },
      test () {
        var value = false
        if (this.login) {
          value = false
        } else value = true
        this.$store.commit('CHANGE_LOGIN', value)
        this.changeNav()
      },

      toggleNav () {
        this.open = !this.open
      },
      changeNav () {
        const desktop = isDesktop()
        this.docked = desktop

        if (!this.login) {
          this.open = false
        } else {
          if (desktop === this.desktop) return
          if (!desktop && this.desktop && this.open) {
            this.open = false
          }
          if (desktop && !this.desktop && !this.open) {
            this.open = true
          }
          this.desktop = desktop
        }
      },
      handleMenuChange (path) {
        if (!this.desktop) this.open = false
      },
      setTitle () {
        let path = window.location.hash
        if (path && path.length > 1) path = path.substring(1)
        for (let i = 0; i < this.routes.length; i++) {
          var route = this.routes[i]
          if (route.path === path) {
            this.title = path.substring(1) || ''
            return
          }
        }
      },

      logout () {
        this.$store.commit(types.LOGOUT)
        this.$store.commit('CLEAR_NOTIFICATION')
        // this.$notify({
        //   group: 'content-notification',
        //   clean: true,
        //   speed: 1
        // })
        this.$notify({
          group: 'top-right-common',
          clean: true,
          speed: 1
        })
        // this.$notify({
        //   group: 'campaign-notification',
        //   clean: true,
        //   speed: 1
        // })
        // turn on full page loading animation for logout
        document.getElementById('progress_bar').style.right = '100vw'
        document.getElementById('full-page-loading').classList.add('show')
        document.getElementById('loading-text').innerHTML = 'Logging you out...'
        setTimeout(function () { // fake progress bar animation
          document.getElementById('progress_bar').style.right = '50vw'
        }, 100)
        setTimeout(function () { // fake progress bar animation
          document.getElementById('progress_bar').style.right = '10vw'
        }, 800)
        this.changeNav()
        this.$router.push({path: '/login'})

        if (document.getElementsByClassName('custom-active').length > 0) {
          document.getElementsByClassName('custom-active')[0].classList.remove('custom-active')
        }
      }
    },
    created: function () {
      // if (this.$store.state.system.systemName === 'sensis') {
        // this.changeTheme('sensisTheme')
      // }
      this.routeChange()
    },
    mounted () {
      console.log('System: ' + this.$store.state.system.systemName)
      this.routes = this.$router.options.routes
      this.setTitle()
      this.changeNav()
      this.handleResize = () => {
        this.changeNav()
      }
      window.addEventListener('resize', this.handleResize)
      window.addEventListener('hashchange', () => {
        this.setTitle()
      })
      // remove scroll change number in all number input
      document.addEventListener('mousewheel', function (event) {
        if (document.activeElement.type === 'number') {
          document.activeElement.blur()
        }
      })
    },
    destroyed () {
      window.removeEventListener('resize', this.handleResize)
    }
  }

  function isDesktop () {
    return window.innerWidth > 800
  }
</script>
<style>
  .olark-launch-button{
    display: none!important;
  }
</style>
<style lang="scss">
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    /*margin-top: 60px;*/
  }

  .hide {
    display: none;
  }

  .nav-logo{
    width: 150px;
    display: block;
  }
  .mu-appbar.login-page {
    padding: 0px 15px;
  }

  .right-section {
    text-align: right;
  }

  .left-section {
    text-align: left;
  }

  .center-section {
    text-align: center;
  }
  .mu-dialog{
    position: relative;
  }
  .popup-close-btn{
    position: absolute;
    top: 25px;
    right: 20px;
    cursor: pointer;
    &:hover{
      .mu-icon{
        background: rgba(226, 231, 234, 0.51);
        color: #555559;
      }
    }
    &:active{
      .mu-icon{
        background: #e2e7ea;
      }
    }
  }
  .largeDialog {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    width: 85%;
    max-height: 70%;
    min-height: 545px;

    .mu-dialog-body {
      flex-grow: 2;
      min-height: 400px;
      max-height: 100% !important;
    }
  }
  .menu-icon{
    .mu-icon{
      font-size: 30px;
      margin-left: 6px;
    }
    .mu-flat-button-label{
      padding-left: 2px!important;
      text-transform: none!important;
    }
    &:active{
      color: #002855;
    }
  }
  .adblock-popup-overlay{
    position: fixed;
    background: rgba(0, 0, 0, 0.3);
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99999998;
  }
  .adblock-popup-wrap{
    position: fixed;
    width: 95%;
    height: 95%;
    background: white;
    z-index: 99999999;
    max-width: 700px;
    max-height: 520px;
    margin: auto;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-family: 'Roboto', 'Open Sans', 'Avenir', Helvetica, Arial, sans-serif !important;
    overflow: auto;
    .dialog-title{
      text-align: center;
      border: none;
      display: block;
      font-size: 24px;
      padding: 35px 10px 20px 10px;
      color: black;
    }
    .adblock-popup-text{
      font-size: 24px;
      width: 80%;
      margin: auto;
      color: #5f5f5f;
    }
    .dialog-btn{
      border: none;
      text-align: center;
      align-items: center;
      justify-content: center;
      padding: 30px 5px 50px 5px;
    }
  }
  @media (max-width: 480px) {
    .header-content {
      .mu-appbar-title {
        opacity: 0;
      }
    }
    .mu-appbar.login-page {
      padding: 0px 8px;
    }
    .nav-logo{
      width: 130px;
      margin-left: 10px;
    }
    #nav-title{
      display: none;
    }

    .adblock-popup-wrap{
      .dialog-title{
        font-size: 18px;
      }
      .adblock-popup-text{
        font-size: 18px;
      }
    }
  }

  /**
  tooltip
   */
  .tooltip {
    display: block !important;
    z-index: 10000;
    max-width: 400px;

    .tooltip-inner {
      background: black;
      color: white;
      border-radius: 16px;
      padding: 10px 10px 9px;
    }

    .tooltip-arrow {
      width: 0;
      height: 0;
      border-style: solid;
      position: absolute;
      margin: 5px;
      border-color: black;
      z-index: 1;
    }

    &[x-placement^="top"] {
      margin-bottom: 5px;

      .tooltip-arrow {
        border-width: 5px 5px 0 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        bottom: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
      }
    }

    &[x-placement^="bottom"] {
      margin-top: 5px;

      .tooltip-arrow {
        border-width: 0 5px 5px 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-top-color: transparent !important;
        top: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
      }
    }

    &[x-placement^="right"] {
      margin-left: 5px;

      .tooltip-arrow {
        border-width: 5px 5px 5px 0;
        border-left-color: transparent !important;
        border-top-color: transparent !important;
        border-bottom-color: transparent !important;
        left: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
      }
    }

    &[x-placement^="left"] {
      margin-right: 5px;

      .tooltip-arrow {
        border-width: 5px 0 5px 5px;
        border-top-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        right: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
      }
    }

    &.popover {
      $color: #f9f9f9;

      .popover-inner {
        background: $color;
        color: black;
        padding: 24px;
        border-radius: 5px;
        box-shadow: 0 5px 30px rgba(black, .1);
      }

      .popover-arrow {
        border-color: $color;
      }
    }

    &[aria-hidden='true'] {
      visibility: hidden;
      opacity: 0;
      transition: opacity .15s, visibility .15s;
    }

    &[aria-hidden='false'] {
      visibility: visible;
      opacity: 1;
      transition: opacity .15s;
    }
  }
  .notificationDialog {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    width: 85%;
    max-height: 70%;
    min-height: inherit!important;
    position: relative;

    .mu-dialog-body {
      padding-top: 10px;
      flex-grow: 2;
      max-height: 100%!important;
      min-height: inherit!important;
    }
  }
  @media (max-width: 480px) {
    .notificationDialog {
      height: auto!important;
    }
  }
</style>

<style scoped lang="scss">
  .checkin-background {
    background-color: white;
  }

  .content{
    overflow: hidden;
    padding-top: 56px;
    padding-left: 256px;
    transition: all .45s cubic-bezier(.23,1,.32,1);
    &.nav-hide {
      padding-left: 0;
    }
    &.hide-bar {
      padding: 0px;
    }
  }

  .header-content {
    position: fixed;
    text-align: left;
    left: 256px;
    right: 0px;
    width: auto;
    transition: all .45s cubic-bezier(.23,1,.32,1);
    justify-content: flex-end;
    background: #fff;
    color: #000;
    &.nav-hide {
      left: 0px;
    }
    &.login-page{
      background: #002855;
      color: #fff;
    }
  }
  .top-button {
    margin: 12px;
    min-width: 50px;
    height: 30px;
  }

  .bottom-image {
    &.mobile {
      display: none;
    }
    &.desktop {
      display: block;
    }
  }

  @media (min-width: 480px) {
    .content{
      padding-top: 64px;
    }
  }
  @media (max-width: 800px) {
    .header-content {
      left: 0;
    }
    .content{
      padding-left: 0;
    }
    #nav-title{
      font-size: 18px;
    }
  }
  @media (max-width: 480px) {
    .top-button {
      margin-right: 3px;
      margin-left: 3px;
    }
    #nav-title{
      font-size: 16px;
    }
    .header-content{
      background: #002855;
      color: #fff;
      .menu-icon{
        color: #fff!important;
      }
    }
    .bottom-image {
      &.mobile {
        display: block;
      }
      &.desktop {
        display: none;
      }
    }
  }


</style>



// WEBPACK FOOTER //
// App.vue?50e39c0c